/* eslint-disable global-require */
module.exports = ['lots.searchbars.common.count.multiple-results', 'lots.searchbars.common.count.one-result'];
